import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import type { UserLink } from './types';
function isLinkActive(link: UserLink, useLocation = false) {
  if (typeof link === 'string') return false;
  const linkActive = link.active === 'active';
  if (!useLocation) return linkActive;
  if (!link.href) return linkActive;
  let pathname = link.href;
  try {
    pathname = new URL(link.href).pathname;
  } catch {
    // probs a relative link, or with only a hash
  }
  return pathname === window.location.pathname || linkActive;
}
function useLinkItemActive(link) {
  const $ = _c(5);
  let t0;
  if ($[0] !== link) {
    t0 = isLinkActive(link, false);
    $[0] = link;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [active, setActive] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== link) {
    t1 = () => {
      setActive(isLinkActive(link, true));
    };
    t2 = [link];
    $[2] = link;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return active;
}
export default useLinkItemActive;